if (!customElements.get('product-quick-view')) {
    class ProductQuickView extends HTMLElement {
        constructor() {
            super();
            if(!window.quickview || window.innerWidth > 768) {
//                 return;
            }
            this.link = this.querySelector('a');
            this.popup = document.getElementById('quickview');
            if(!this.popup) {
                return;
            }
            
            this.popup.addEventListener('click', this.onPopupClick.bind(this))
            this.popup.addEventListener('keydown', this.onPopupKeydown.bind(this))
            this.close = this.popup.querySelectorAll('[data-close]')
            if(this.close) {
                this.close.forEach((close)=>{
                    close.addEventListener('click', this.onClose.bind(this))
                })
            }

            this.link.addEventListener('click', (event) => {

                event.preventDefault();

                this.activeElement = document.activeElement;
                document.querySelector('body').classList.add('fav-popup-open')
                this.popup.classList.add('active')
                this.popup.querySelector('.content').innerHTML = '';
                this.popup.querySelector('.loading-overlay').classList.remove('hidden');
                if (typeof trapFocus === 'function') {
                    const focusTarget = this.popup.querySelector('[data-close]') || this.popup;
                    trapFocus(this.popup, focusTarget);
                }

                var self = this;
                var http = new XMLHttpRequest();

                http.onreadystatechange = function () {
                    if (this.readyState == 4) {
                        try {
                            // Convert the HTML string into a document object
//                             var parser = new DOMParser();
//                             var doc = parser.parseFromString(this.response, 'text/html');
//                             var elm = self.popup.querySelector('.content');
//                             elm.innerHTML = doc.querySelector('#MainContent').innerHTML;
//                             elm.classList.remove('loading');
//                             elm.querySelector('.shopify-payment-button').remove();
//                             Array.from(elm.querySelectorAll("script:not([src])")).forEach( oldScript => {
//                                 const newScript = document.createElement("script");
//                                 Array.from(oldScript.attributes).forEach( attr => newScript.setAttribute(attr.name, attr.value) );
//                                 newScript.appendChild(document.createTextNode(oldScript.innerHTML));
//                                 oldScript.parentNode.replaceChild(newScript, oldScript);
//                             });
//                             let event = new Event("swiper-loaded", {bubbles: true});
                            console.log('quickview');
//                             document.body.dispatchEvent(event);
                            if (typeof trapFocus === 'function' && self.popup.classList.contains('active')) {
                                const refreshedFocusTarget = self.popup.contains(document.activeElement) ? document.activeElement : (self.popup.querySelector('[data-close]') || self.popup);
                                trapFocus(self.popup, refreshedFocusTarget);
                            }
                        } catch(err) {
                            console.log(err.message + " in " + this.response);
                            return;
                        }
                    }
                };

                let url = this.link.href;
                if(url.includes('?')) {
                    url += '&view=quickview'
                } else {
                    url += '?view=quickview'
                }

                http.open('GET', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.send();
            });
        }

        onClose(event) {
            event.preventDefault();
            document.querySelector('body').classList.remove('fav-popup-open')
            this.popup.classList.remove('active')
            if (typeof removeTrapFocus === 'function') {
                removeTrapFocus(this.activeElement || this.link);
            }
        }

        onPopupClick(event) {
            if(event.target.getAttribute('id') == 'quickview') {
                this.onClose(event);
            }
        }

        onPopupKeydown(event) {
            if (event.key === 'Escape') {
                event.preventDefault();
                this.onClose(event);
            }
        }
    }

    customElements.define('product-quick-view', ProductQuickView);
}